import Market from '@/creditflowresearch/domain/Market';

const getMarketPrefixForTitle = (marketIds: string[], separator: string = ' '): string => {
  if (marketIds.length === 1) {
    const [marketId] = marketIds;
    const market = Market.from(marketId);

    if (!market) {
      return '';
    }

    return market.getDisplayName() + separator;
  }

  return '';
};

export default getMarketPrefixForTitle;
